var _defs, _ellipse, _line, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1172({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 9.27,
    cy: 6.76,
    rx: 5.73,
    ry: 5.64
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 5.21,
    y1: 10.74,
    x2: 1,
    y2: 14.88
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.8,8.26h-1V8A1.73,1.73,0,0,1,9,7.2a2.43,2.43,0,0,1,.64-.7A4.51,4.51,0,0,0,10.17,6a.68.68,0,0,0,.15-.42A.71.71,0,0,0,10.06,5a1,1,0,0,0-.69-.23,1,1,0,0,0-.7.24,1.25,1.25,0,0,0-.38.72l-1-.12a1.67,1.67,0,0,1,.59-1.19A2.15,2.15,0,0,1,9.32,4a2.2,2.2,0,0,1,1.51.5,1.5,1.5,0,0,1,.56,1.15,1.27,1.27,0,0,1-.21.69,4.4,4.4,0,0,1-.88.88,1.83,1.83,0,0,0-.43.46A1.63,1.63,0,0,0,9.8,8.26Zm-1,1.48V8.64H9.9v1.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1172);
export default __webpack_public_path__ + "static/media/Symbolpack_1_172.c13e677437b99d1a275bf2776eb670ee.svg";
export { ForwardRef as ReactComponent };